import { Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
// import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
// import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

const Home = () => {
    const theme = useTheme();

    return (
        <Grid
            className="home-container"
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                color: theme.palette.primary[600],
                gap: "10px",
            }}
        >
            <Grid>
                <Typography
                    sx={{
                        fontSize: "2em",
                        fontWeight: "bold",
                    }}
                >
                    Connected Services AI Assistant
                </Typography>
            </Grid>
            <Grid
                sx={{
                    display: "flex",
                    gap: "10px",
                }}
            >
                {/* <Grid
                    sx={{
                        display: "flex",
                        padding: "5px",
                        backgroundColor: theme.palette.primary[50],
                        borderRadius: "5px",
                        gap: "5px",
                    }}
                >
                    <RocketLaunchIcon />
                    <Typography
                        sx={{
                            fontSize: "0.8em",
                            fontWeight: "bold",
                        }}
                    >
                        OTA (Over The Air Updates)
                    </Typography>
                </Grid> */}
                {/* <Grid
                    sx={{
                        display: "flex",
                        padding: "5px",
                        backgroundColor: theme.palette.primary[50],
                        borderRadius: "5px",
                        gap: "5px",
                    }}
                >
                    <AccountBalanceWalletIcon />
                    <Typography
                        sx={{
                            fontSize: "0.8em",
                            fontWeight: "bold",
                        }}
                    >
                         Entitlement Management
                    </Typography>
                </Grid> */}
            </Grid>
        </Grid>
    );
}

export default Home;